import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, UserService, NotificationService } from 'yt-ng-framework';
import { ZbirniDnevnik } from './zbirni-dnevnik';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
//import { defaultUrlMatcher } from '@angular/router/src/shared';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-zbirni-dnevnik-update',
  templateUrl: './zbirni-dnevnik-update.component.html'
})
export class ZbirniDnevnikUpdateComponent extends BaseUpdateComponent<ZbirniDnevnik> implements OnInit {
  ukupnoUlaz: number=0;
  ukupnoIzlaz: number=0;
  ukupnoRazlika: number=0;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    public userService: UserService
  ) { 
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Datum", Validators.required, 'required', 'ZBIRNIDNEVNIK.DATUM.VALIDATION.REQUIRED');
    this.onChange();

    this.IDProcessed
    .subscribe((value) => {
        if (value && this.Item.ID == -1) {
            let dateNow = new Date();
            let date: NgbDate = new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate());
            this.baseFormGroup.patchValue({ Datum: date });
            this.baseFormGroup.get('Datum').updateValueAndValidity();
        }
    })

  }

  async SaveItem(){
    this.baseFormGroup.get("Vrsta").setValue("X");
   
    await super.SaveItem();
  }

  onChange(): void {
    this.baseFormGroup.valueChanges.subscribe(val => {
      this.ukupnoUlaz=Number(val.UPs)
        +Number(val.UUlDinSaRacuna)
        +Number(val.UUlDinIsplNaBlagajni)
        +Number(val.UIntUlSaDrBlagMesta)
        +Number(val.UIntUlSaDrMenjMesta)
        +Number(val.UIntUlUBlagPlatneUsluge)
        +Number(val.UUkUplProdajaEfektive)
        +Number(val.UUlDinSaBankomata)
        +Number(val.UUlDinSaPrivrBlagMesta)
        +Number(val.UUlDinOdPutMenjaca)
        +Number(val.UUnpProdajaEfektive)
        +Number(val.UUnpOtkupEfektive)
        +Number(val.UUnpOtkupInValuta)
        +Number(val.UUnpOtkupOsteceneEfektive)
        +Number(val.UUnpOtkupVanoptEfektive)
        +Number(val.UUnpZamenaOsteceneEfektive)
        +Number(val.UUnpZamenaVanoptEfektive)
        +Number(val.IUlDinPlatUsl);
      this.ukupnoIzlaz=Number(val.IIntIzNaDrBlagMesto)
        +Number(val.IIntIzNaDrMenjMesto)
        +Number(val.IIntIzPlatneUsluge)
        +Number(val.IUkupnoOtkupEfektive)
        +Number(val.IBankomat)
        +Number(val.IPrivrBlagMesto)
        +Number(val.IPutMenjacu)
        +Number(val.IRadiKupovineEfektive)
        +Number(val.IUplataNaTekRacun)
        +Number(val.IIsknjizavanjeProvizije)
        +Number(val.IKursneRazlike)
        +Number(val.IIzDinPlatUsl);
      this.ukupnoRazlika=this.ukupnoUlaz-this.ukupnoIzlaz;
    });
  }

  onDatumChange(value) {
    if (this.Item.ID == -1){
      if (value != null) {
        let datum: NgbDate = new NgbDate(value["year"], value["month"], value["day"]);
        this.baseDataService.GetData('ZbirniDnevnik', 'GetDnevnikPSByDatum', {'Datum': datum})
        .subscribe(data => {
        this.baseFormGroup.patchValue({ UPs: data });
        this.baseFormGroup.get('UPs').updateValueAndValidity();
        })
      }
    }
  }
}
